module.exports = __webpack_public_path__ + "static/media/19.522db330.jpg";